import { Box, Dialog, DialogContent, DialogTitle } from '@mui/material';

import { ProfesionalForm } from '@/features/profesionales/components/ProfesionalForm';
import { useCreateProfesional } from '@/features/profesionales/hooks/useProfesionales';
import type { ProfesionalFormValues } from '@/features/profesionales/schemas';

interface CrearProfesionalDialogProps {
  open: boolean;
  onCreated: (uid: string) => void;
  onCancel: () => void;
}

export function CrearProfesionalDialog({
  open,
  onCreated,
  onCancel,
}: CrearProfesionalDialogProps): JSX.Element {
  const mutation = useCreateProfesional();

  async function handleSubmit(values: ProfesionalFormValues): Promise<void> {
    const created = await mutation.mutateAsync({
      nombre_apellido: values.nombre_apellido,
      tipo_profesional: values.tipo_profesional,
      tipo_profesional_otro: values.tipo_profesional_otro || null,
      telefono_whatsapp: values.telefono_whatsapp || null,
      emails: values.emails,
      localidad: values.localidad || null,
      envio_informe: values.envio_informe,
    });
    onCreated(created.uid_profesional);
  }

  return (
    <Dialog open={open} onClose={onCancel} fullWidth maxWidth="sm">
      <DialogTitle>Nuevo profesional</DialogTitle>
      <DialogContent>
        <Box sx={{ pt: 1 }}>
          <ProfesionalForm
            onSubmit={(v) => void handleSubmit(v)}
            onCancel={onCancel}
            submitLabel="Crear profesional"
            submitting={mutation.isPending}
            error={mutation.error}
          />
        </Box>
      </DialogContent>
    </Dialog>
  );
}
